module.exports = {
      id: "social-youtube-usage",
      viewBox: "0 0 500 500",
      url: __webpack_public_path__ + "images/sprites.min-11be54f7479b06d185ecfa466b4f4f22.svg#social-youtube-usage",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__vegkit/components/site/sprites/social-youtube.svg
// module id = /tool/node_modules/svg-sprite-loader/lib/loader.js??ref--8-0!/tool/project/client/src/site__vegkit/components/site/sprites/social-youtube.svg
// module chunks = site__vegkit